<div [ngClass]="['container-geral', animationOut ? 'animated fadeOutRight faster ' : '']">
	<tela-cadastro side="left" fundo="login">
		<div class="container-boas-vindas">
			<span class="title-small">Seja bem-vindo!</span>
			<span class="subtitle-small">Faça login na sua conta:</span>
		</div>
		<form [formGroup]="formLogin" class="form-login">
			<div>
				<div>
					<mat-form-field>
						<mat-label>E-mail</mat-label>
						<input autofocusautocomplete="off"
								formControlName="email"
								name="username"
								matInput type="email" 
								spellcheck="false">
						<mat-error *ngIf="errorMessage(formLogin.get('email'))">{{errorMessage(formLogin.get('email'))}}</mat-error>
					</mat-form-field>
				</div>
				<div class="mt-16">
					<mat-form-field>
						<mat-label>Senha</mat-label>
						<input autocomplete="off"
								name="password"
								formControlName="senha"
								matInput [type]="mostrarSenha ? 'text' : 'password'">						
							<mat-icon class="buttonVisibleSenha" matSuffix [svgIcon]="mostrarSenha ? 'eye-off' : 'eye'" (click)="visibilidadeSenha($event)"></mat-icon>						
						<mat-error *ngIf="errorMessage(formLogin.get('senha'))">{{errorMessage(formLogin.get('senha'))}}</mat-error>
						<small *ngIf="tentativasLogin >= 3 && tentativasLoginBackground < 5 && !errorMessage(formLogin.get('senha'))" class="tentativasLogin">
							{{tentativasLogin}} tentativas de acesso							
						</small>
						<small *ngIf="tentativasLoginBackground >= 5 && !errorMessage(formLogin.get('senha'))" class="tentativasLogin">
							Não esta lembrando da senha? Clique em "Esqueci minha senha" logo abaixo
						</small>
					</mat-form-field>
				</div>
				<div>					
						<button mat-raised-button 
								[ngClass]="['botao-login', loading ? 'color-botao-loginLoading' : 'color-botao-login']"
								[ngStyle]="{width:'100%'}"
								(click)="fazLogin()" 
								[disabled]="loading || (!formLogin.get('email').valid && formLogin.touched) || (!formLogin.get('senha').valid && formLogin.touched) || bloquerBtnLogin || deslogando || btnDisabled" 
								isRoundButton="true"
								padding>
							{{!loading ? 'ENTRAR' : '' }}
							<mat-icon *ngIf="loading" [svgIcon]="'loading'" class="loading">
							</mat-icon>
						</button>
				</div>					
				<div [ngClass]="['links-a-esquerda', 'mt-16', 'link-esqueci-senha']">
					<a margin routerLink="/recuperar-senha" mat-button color="primary">Esqueci minha senha</a>
				</div>
				<!-- <div [ngClass]="['links-centralizados', 'link-criar-conta']">
					<a margin routerLink="/criar-conta" mat-button>Ainda não tem uma conta? <b>Criar Conta</b></a>
				</div> -->
			</div>
		</form>
	</tela-cadastro>

</div>